// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2aARh","footer":"ReportModalFilter_footer__9ubDI"};